export default {
    zip_code: $('#zip_code'),
    street: $('#street'),
    number: $('#number'),
    neighborhood: $('#neighborhood'),
    city: $('#city'),
    state: $('#state'),

    _createSelectStates(value) {
        console.log(value);

        let list = [
            '',
            'AC',
            'AL',
            'AP',
            'AM',
            'BA',
            'CE',
            'DF',
            'ES',
            'GO',
            'MA',
            'MS',
            'MT',
            'MG',
            'PA',
            'PB',
            'PR',
            'PE',
            'PI',
            'RJ',
            'RN',
            'RS',
            'RO',
            'RR',
            'SC',
            'SP',
            'SE',
            'TO',
        ];

        this.state.find('option').remove().end();

        for(let i = 0; i < list.length; i++) {
            let checked = list[i] == value ? 'selected' : '';

            this.state.append('<option value="'+ i +'" '+ checked +'>'+ list[i] +'</option>');
        }
    },
    _getAddress(zip_code) {
        let url = 'https://viacep.com.br/ws/'+zip_code+'/json/';

        $.get(url, (result) => {
            this.street.val(result.logradouro);
            this.neighborhood.val(result.bairro);
            this.city.val(result.localidade);
            this._createSelectStates(result.uf);

            this.street.removeAttr('disabled').parent().parent().find('small').addClass("active");
            this.number.removeAttr('disabled').parent().parent().find('small').addClass("active");
            this.neighborhood.removeAttr('disabled').parent().parent().find('small').addClass("active");
            this.city.removeAttr('disabled').parent().parent().find('small').addClass("active");
            this.state.removeAttr('disabled').parent().parent().find('small').addClass("active");
        }).fail(() => {
            alert("CEP não encontrado!");
        });
    },
    _attachOnBlur() {
        var self = this;

        this.zip_code.on('blur', function () {
            self._getAddress($(this).val());
        });
    },
    fire() {
        this.street.attr('disabled', 'disabled');
        this.number.attr('disabled', 'disabled');
        this.neighborhood.attr('disabled', 'disabled');
        this.city.attr('disabled', 'disabled');
        this.state.attr('disabled', 'disabled');

        this._attachOnBlur();
    },
}


// WEBPACK FOOTER //
// ./scripts/components/via-cep.js